import React from 'react';

const problemas = [
  'Son olvidadas pocos días después.',
  'No generan cambios de hábitos sostenibles.',
  'Presentan baja participación de los colaboradores.',
  'Carecen de medición e impacto.',
  'No logran conectar con las necesidades reales de los equipos.',
];

const Problema = () => {
  return (
    <section id="problema" className="section bg-white">
      <div className="container max-w-3xl">
        <h2 className="heading-2 mb-6">
          ¿Por qué muchas iniciativas de bienestar{' '}
          <em>no generan resultados?</em>
        </h2>
        <p className="body-large mb-8">
          Las empresas invierten en actividades aisladas que:
        </p>
        <ul className="lista-problema mb-10">
          {problemas.map((problema) => (
            <li key={problema}>{problema}</li>
          ))}
        </ul>
        <p className="body-large" style={{ color: 'var(--verde-oscuro)', fontWeight: 500 }}>
          En Nútrete creemos que el bienestar corporativo debe ser práctico,
          participativo y basado en evidencia.
        </p>
      </div>
    </section>
  );
};

export default Problema;
